export function hashString(value: string): string {
  let hash = 0
  let chr: number
  if (value.length === 0) return `${hash}`
  for (let index = 0; index < value.length; index++) {
    chr = value.charCodeAt(index)
    hash = (hash << 5) - hash + chr
    hash |= 0
  }
  return `${hash}`
}

export function parseString(stringToParse?: string | null) {
  if (stringToParse === "false") return false
  if (stringToParse === "true") return true
  return stringToParse
}

declare global {
  interface String {
    capitalize(): string
    startsWithNumber(): boolean
  }
}

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase()
}

String.prototype.startsWithNumber = function (): boolean {
  return !!this.match(/^\d/)
}
